import { apiClient } from "@/api/api-client";
import { ApiResponse } from "@/types/api-response";
import {
  Pickup,
  PickupCreateRequest,
  PickupUpdateRequest,
} from "@/types/pickup-type";
import { endpoints } from "./endpoints/endpoints";

export async function getPickup(id: string): Promise<ApiResponse<Pickup>> {
  try {
    const response = await apiClient.get<Pickup, void>(
      endpoints.pickup.get(id)
    );
    return response as ApiResponse<Pickup>;
  } catch (error) {
    console.error("Error getting pickup:", error);
    throw error;
  }
}

export async function createPickup(
  request: PickupCreateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.post(endpoints.pickup.create, request);
    console.log("Pickup created:", response.data);
    return response.data as ApiResponse<any>;
  } catch (error) {
    console.error("Error creating pickup:", error);
    throw error;
  }
}

export async function updatePickup(
  id: string,
  request: PickupUpdateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.put(endpoints.pickup.update(id), request);
    console.log("Pickup updated:", response.data);
    return response.data as ApiResponse<any>;
  } catch (error) {
    console.error("Error updating pickup:", error);
    throw error;
  }
}

export async function deletePickup(id: string): Promise<ApiResponse<Pickup>> {
  try {
    const response = await apiClient.delete<Pickup>(
      endpoints.pickup.delete(id)
    );
    return response;
  } catch (error) {
    console.error("Error deleting pickup:", error);
    throw error;
  }
}
